import GlobalMixin from '@/app/shared/mixins/global';

export default {
    mixins: [
        GlobalMixin
    ],
    inject: {
        parentValidator: 'parentValidator'
    },
    props: {
        configId: {
            type: String,
            default: 'print_manage'
        },
        value: {
            type: Object,
            default: null
        },
        vScope: {
            type: String,
            default: 'form'
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            lists: {
                loaded: false,
                onoff: [{'id': 1, 'name': 'Sim', 'code': 1}, {'id': 2, 'name': 'Não', 'code': 0}],
            },
            form: {
                status: 0,
            },
        }
    },
    created: function () {
        this.$validator = this.parentValidator;
    },
    beforeMount () {
        this.copyValue(this.value)
    },
    methods: {
        copyValue (value) {
            Object.assign(this.form, value);
        },
    },
    watch: {
        value (newValue) {
            this.copyValue(newValue)
        },
        form: {
            handler(value, oldValue){
                this.$emit('input', value);
            },
            deep: true,
        },
    },
};